<template>
  <div id="slide-7" class="slide pt-37.5 mx-23.5 h-screen relative flex flex-col gap-12.5">
    <div class="flex items-center justify-between section-header">
      <img src="@/assets/images/volume.svg" class="w-10 h-10 " alt="" />
      <p class="uppercase font-medium fz-10" style="line-height: 1; color: #6e758d; letter-spacing: 0.3rem" >{{ text.blogName }}</p>
    </div>
    <slider
        :slides-container-classes="'mb-5 gap-10 min-h-104 ml-15'"
        :slider-classes="''"
        :similar-slides="true"
        :pagination="true"
        pagination-container-classes="gap-5 mt-25 ml-15"
        class="mb-12.5 "
    >
      <template v-slot:slides>
        <div
            class="slider-slide  w-76.25 flex flex-col relative"
            :class="{'active-slide': index === 0}"
            v-for="(item, index) in text.news"
            :key="index"
        >
          <div class="text relative w-76.25 h-37.5 mb-6">
            <p class="w-55 unactive fz-15 font-medium" style="color: rgba(110, 117, 141, 1);line-height:1.66666;">{{ item.text }}</p>
            <p class="absolute top-0 left-0 active fz-18" style="line-height:1.36666;">{{ item.text }}</p>
          </div>
          <div class="image">
            <img  :src="require('@/assets/images/slide_6/' + item.image + '.png')" alt="">
          </div>
          <div class="naw-arrow absolute" >
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                stroke="white"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M12 17L19 10L12 3"
                  stroke-width="2"

                  stroke-linejoin="round"
              />
              <path d="M5 10L19 10" stroke-width="2" stroke-linejoin="round" />
            </svg>
          </div>
        </div>
      </template>
      <template v-slot:pagination>
        <div class="w-1.25 h-1.25 rounded-full bg-white"></div>
      </template>
    </slider>


    <a href="#mobile-start" class="all-projects flex justify-end items-center absolute bottom-60 right-0" @click="setRoute('blog')">
      <p class="uppercase fz-13 font-semibold mr-5" style="line-height: 1;">{{text.all}}</p>
      <div class="plus relative w-12.5 h-12.5 rounded-full" style="background:#fff;" >
        <div class="w-4 h-2px absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#ff2e53;"></div>
        <div class="w-2px h-4 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#ff2e53;"></div>
      </div>
    </a>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import slider from "@/components/tablet/reuseable/slider";

export default {
  name: "slide7",
  components:{slider},
  data() {
    return {
      hover: false,
      hoverIndex: null,
    };
  },
  methods: {
    ...mapMutations(['setRoute']),
    hoverStart(index) {
      this.hover = true;
      this.hoverIndex = index;
    },
    hoverEnd() {
      this.hover = false;
      this.hoverIndex = null;
    },
  },
  computed: {
    text() {
      return require("@/assets/text/main/slide6/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  },
};
</script>

<style lang="scss" scoped>

.slider-slide{
  p,img, .naw-arrow{
    transition: all linear .3s;
  }
  p.active{
    opacity: 0;
  }
  p.unactive{
    opacity: 1;
  }
  img{
    width: 10.625rem;
  }
  .naw-arrow{
    opacity: 0;
    bottom: 5rem;
  }
}
.slider-slide.active-slide{
  p.active{
    opacity: 1;
  }
  p.unactive{
    opacity: 0;
  }
  img{
    width: 19.0625rem;
  }
  .naw-arrow{
    opacity: 1;
    bottom: -2.5rem;
  }
}
.pagination {
  transition: all linear 0.3s;
}
.pagination > div > * {
  transition: all linear 0.3s;
}
.pagination .active {
  width: 2.5rem;
  height: 0.25rem;
  background: rgba(255, 46, 83, 1);
}
</style>
